export default __webpack_public_path__ + "static/media/vitalsmd-portal-nav-logo.18b2e4f4.svg";